import {clearAddress} from "./addressSlice";
import {resetDocuments} from "./documentsSlice";
import {abortRunningIndications} from "./indicationRequests";
import {clearAllLocationInfoData} from "./locationInfoSlice";
import {resetMarketDataInput} from "./marketDataInputSlice";
import {resetNotifications} from "./notificationsSlice";
import {resetObjectInformation} from "./objectInformationSlice";
import {resetObjectParameters} from "./objectParametersSlice";
import {resetPersistence} from "./persistenceSlice";
import {resetPoolStatistics} from "./poolStatisticsSlice";
import type {RevaThunkAction} from "./revaHooks";
import {resetSnapshots} from "./searchSnapshotsSlice";
import {resetValuations} from "./searchValuationsSlice";
import {resetUiPreferences} from "./uiPreferencesSlice";
import {clearIndicationData} from "./valueIndicationSlice";
import {resetValueOrders} from "./valueOrdersSlice";

/**
 * Reset the whole state of a loaded valuation (unload a valuation).
 *
 * Runs synchronously: once `dispatch(resetAll())` returns, the store is reset. That alone is not
 * enough to then navigate away, though - the effects reconciling the URL with the store react to
 * the emptied store before a navigation issued afterwards has committed, and the last navigate()
 * wins. Unloading AND navigating therefore goes through `useUnloadValuation`.
 */
export const resetAll = (): RevaThunkAction<void> => (dispatch) => {
    // Zuerst: laufende Indikationen der abgeräumten Bewertung abbrechen, damit ihre Antwort nicht in
    // der danach geladenen Bewertung landet (#19374).
    abortRunningIndications();
    // Diese Redux Reducer werden synchron ausgeführt, ein await ist also nicht nötig
    dispatch(resetObjectParameters());
    dispatch(resetObjectInformation());
    dispatch(clearIndicationData());
    dispatch(clearAllLocationInfoData());
    dispatch(clearAddress());
    dispatch(resetPersistence());
    dispatch(resetDocuments());
    dispatch(resetNotifications());
    dispatch(resetValuations());
    dispatch(resetSnapshots());
    dispatch(resetValueOrders());
    dispatch(resetPoolStatistics());
    dispatch(resetUiPreferences());
    dispatch(resetMarketDataInput());
};
